import styled from 'styled-components';
import { ListaComponent } from './../../../Componentes/components';

export const NotificacoesConsultarComponent = styled(ListaComponent).attrs({
    className: `painel-consulta border-0`
})`
    

`